// convex/lib/config/domains/notifications.ts

import { validatorNotification } from "../../../system/notifications";
import { validatorUsers } from "../../../system/users";
import type { DomainGroup, TableScope } from "../types";

export const notificationsDomain: DomainGroup = {
  id: "notifications",
  name: "Notificaciones",
  description: "Sistema de notificaciones",
  icon: "Bell",
  order: 103,
  status: "active",
  modules: [
    {
      id: "notifications",
      name: "Notificaciones",
      description: "Centro de notificaciones del sistema",
      icon: "Bell",
      permissions: ["canRead", "canUpdate"],
      routes: ["/settings/notifications"],
      navigation: {
        showInNav: true,
        contexts: ["settings"],
        navOrder: 15,
        status: "active",
      },
      tables: [
        {
          tableName: "notifications",
          schema: validatorNotification,
          scope: "company" as TableScope,
          relations: [
            { key: "user", schema: validatorUsers, tableName: "users" },
          ],
          searchFields: ["title", "message", "type"],
          hasStatusIndex: false,
        },
      ],
      readOnlyTables: [
        { tableName: "users" },
        { tableName: "companies" },
        { tableName: "reports" },
        { tableName: "report_executions" },
      ],
    },
  ],
};
